export default "__VITE_ASSET__$0bnqOTx__"